/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Contact_IntroInputs */

const en_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For all privacy-related inquiries, please contact:`)
};

const de_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für alle datenschutzbezogenen Anfragen kontaktieren Sie bitte:`)
};

const fr_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour toute question relative à la vie privée, veuillez contacter :`)
};

const es_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para todas las consultas relacionadas con la privacidad, contacte a:`)
};

const it_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per tutte le richieste relative alla privacy, contattare:`)
};

const nl_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem voor alle privacygerelateerde vragen contact op met:`)
};

const pl_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We wszystkich sprawach dotyczących prywatności prosimy o kontakt:`)
};

const fi_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikissa tietosuojaan liittyvissä kyselyissä ota yhteyttä:`)
};

const da_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For alle privatlivsrelaterede henvendelser, kontakt venligst:`)
};

const sv_privacy_contact_intro = /** @type {(inputs: Privacy_Contact_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`För alla integritetsrelaterade frågor, vänligen kontakta:`)
};

/**
* | output |
* | --- |
* | "For all privacy-related inquiries, please contact:" |
*
* @param {Privacy_Contact_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_contact_intro = /** @type {((inputs?: Privacy_Contact_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Contact_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_contact_intro(inputs)
	if (locale === "fr") return fr_privacy_contact_intro(inputs)
	if (locale === "es") return es_privacy_contact_intro(inputs)
	if (locale === "it") return it_privacy_contact_intro(inputs)
	if (locale === "nl") return nl_privacy_contact_intro(inputs)
	if (locale === "pl") return pl_privacy_contact_intro(inputs)
	if (locale === "fi") return fi_privacy_contact_intro(inputs)
	if (locale === "da") return da_privacy_contact_intro(inputs)
	if (locale === "sv") return sv_privacy_contact_intro(inputs)
	return en_privacy_contact_intro(inputs)
});